<div class="pageheader">
    <div class="page-title">
        <h1>Error codes</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <!-- TODO: Button removed until we have fully refined how we want Categories to work from both a techincal and UX perspective -->
            <!-- <button class="btn btn-link" *bizPermissionRequired="'Developer_Action_ErrorCategory_Create'"
                (click)="newCategory()">New category
                <ep-svg-icon icon="plus"></ep-svg-icon>
            </button> -->
            <button class="btn btn-link" *bizPermissionRequired="'Developer_Action_ErrorCode_Create'"
                (click)="createErrorCode()">New error code
                <ep-svg-icon icon="plus"></ep-svg-icon>
            </button>
            <button class="btn btn-link" (click)="generateNewErrorCode()">Generate code
                <ep-svg-icon icon="paper"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Error codes log'">
                <app-change-log-link-entity type="ExceptionType"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-12">
        <dx-data-grid #errorCodeGrid biz-grid [selection]='{ mode: "none" }' [dataSource]='exceptionTypes'
                      [bizSetColumnChooser]="true" [bizSetAllowColumnReordering]="true" [bizSetPager]="true"
                      (onInitNewRow)="onInitNewRow($event)" (onRowInserting)="onRowInserting($event)"
                      (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)" [bizEditRowOnDoubleClick]="true">

            <dxo-editing mode="popup" [allowAdding]="allowAdding" [allowUpdating]="allowUpdatingRow"
                         [allowDeleting]="allowDeletingRow">
                <dxo-popup title="Error code" [showTitle]="true"></dxo-popup>
            </dxo-editing>

            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

            <dxi-column dataField="ErrorCode" caption="Code" dataType="string" width="5%"
                        [allowGrouping]="false" [allowEditing]="false">
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="ExceptionCategoryId" caption="Category" width="15%"
                        editCellTemplate="singleDropDownBoxEditor"  sortOrder="asc">
                <dxo-lookup [dataSource]="exceptionCategories" valueExpr="ExceptionCategoriesId"
                            displayExpr="ExceptionCategoryName"></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="ExceptionCategoryCode" caption="Category code" dataType="string" width="15%"
                        [allowEditing]="false" [formItem]="{visible: false}" [visible]="false">
            </dxi-column>

            <dxi-column dataField="Area" caption="Area" dataType="string" width="10%">
                <dxo-lookup [dataSource]="exceptionTypeAreas" valueExpr="ExceptionTypeAreaId" displayExpr="ExceptionTypeAreaName"></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="Component" caption="Component" dataType="string" width="30%">
            </dxi-column>

            <dxi-column dataField="ExceptionCause" caption="Exception cause" dataType="string" width="30%"
                        [allowGrouping]="false">
            </dxi-column>

            <dxi-column dataField="TechnicalDescription" caption="Technical description" dataType="string"
                        [allowGrouping]="false" [visible]="false">
            </dxi-column>

            <dxi-column dataField="ExceptionSolution" caption="Exception solution" dataType="string"
                        [allowGrouping]="false" [visible]="false">
            </dxi-column>

            <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.exceptionTypes, 'CreatedBy'))"></dxo-header-filter></dxi-column>
            <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
            <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false"><dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.exceptionTypes, 'UpdatedBy'))"></dxo-header-filter>   </dxi-column>
            <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

            <dxi-column type="buttons">
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete"></dxi-button>
                <dxi-button text="Show Log"
                            template="logTemplate"
                            [visible]="allowShowLog">
                </dxi-button>
            </dxi-column>

            <ng-container *dxTemplate="let cell of 'logTemplate'">
                <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.ErrorCode" [showIcon]="false" classNames="dx-link">
                    <app-change-log-link-entity type="ExceptionType" [id]="cell.data.ExceptionTypesId"></app-change-log-link-entity>
                </app-change-log-link>
            </ng-container>

            <div *dxTemplate="let cellInfo of 'singleDropDownBoxEditor'">
                <dx-drop-down-box [dropDownOptions]="dropDownOptions" [dataSource]="exceptionCategories"
                                  [(value)]="cellInfo.value" displayExpr="ExceptionCategoryName" valueExpr="ExceptionCategoriesId"
                                  contentTemplate="contentTemplate">
                    <div *dxTemplate="let e of 'contentTemplate'">
                        <dx-data-grid [dataSource]="exceptionCategories" [remoteOperations]="true" [height]="250"
                                      [selectedRowKeys]="[cellInfo.value]" [focusedRowEnabled]="true"
                                      [focusedRowKey]="cellInfo.value" [hoverStateEnabled]="true"
                                      keyExpr="ExceptionCategoriesId"
                                      (onSelectionChanged)="onSelectionChanged($event.selectedRowKeys, cellInfo, e.component)">
                            <dxi-column caption="Name" sortOrder="asc" width="200"
                                        dataField="ExceptionCategoryName"></dxi-column>
                            <dxi-column caption="Description" width="400" dataField="Description"></dxi-column>
                            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
                            <dxo-scrolling mode="virtual"></dxo-scrolling>
                            <dxo-selection mode="single"></dxo-selection>
                        </dx-data-grid>
                    </div>
                </dx-drop-down-box>
            </div>
        </dx-data-grid>
    </div>
</div>
